<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h2>قانون ها</h2>

            <router-link class="btn btn-primary ml-auto" to="/dashboard/UserRule">ساخت قانون جدید</router-link>
            <div class="table-responsive mt-4">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام قانون</th>
                    <th>وضعیت</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="rule in rules" :key="rule._id">
                    <td>{{ rule.title }}</td>
                    <td>
                      <button class="btn btn-danger mr-4" @click="removeRule(rule)">حذف</button>
                      <router-link :to="{ path: '/dashboard/UserRule', query: { id: rule._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PermissionService from '../../../../services/UsersRulePermissions';
export default {
  name: 'Rules',
  data() {
    return {
      rules: [],
    };
  },
  created() {
    this.getRules();
  },
  methods: {
    async removeRule(rule) {
      try {
        await PermissionService.deleteRule(rule._id);
        window.notif({ mssg: 'قانون با موفقیت حذف شد', isError: false });
        this.getRules();
      } catch (err) {
        console.log(err);
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },

    async getRules() {
      try {
        const resData = await PermissionService.getRules({});
        this.rules = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
